// @flow

export default function getBody (body: Object, asFormData: boolean = false): string | FormData {
  // const UPLOADKEY = 'upload[]'
  if (asFormData) {
    const form_data = new FormData()

    for (let key in body) {
      const bodyData = body[key]
      if (bodyData instanceof Array) {
        const file = body[key]
        for (let index in file) {
          form_data.append(key, file[index])
        }
      } else {
        form_data.append(key, body[key])
      }
    }

    return form_data
  }

  if (typeof body === 'object') {
    try {
      return JSON.stringify(body)
    } catch (error) {
      console.error(error)
    }
  }

  return body
}
